export const getEsignVoidBlockedText = (providerName: string, item: string) => {
  const article = item === 'envelope' ? 'an' : 'a';
  return `${providerName} doesn't allow us to void ${article} ${item} that has already been marked as completed, or declined on their platform.`;
};

export const getEsignReplacementText = (providerName: string, item: string) => {
  const newItem = item === 'envelope' ? 'envelope' : item;
  return `You can still upload a replacement template. We will create a new ${newItem} with the updated information but the old ${item} will still be available on your ${providerName} account.`;
};
